@if (!hidden) {
<button
  type="button"
  mat-icon-button
  class="open-button mat-primary-bg mat-elevation-z2"
  (click)="openBar()"
  data-testid="btn-table-options"
>
  <mat-icon svgIcon="settings"></mat-icon>
</button>
}

<div #overlay class="table-options-panel-overlay" [fxHide]="isBarClosed" [@fadeInOut]="!isBarClosed"></div>

<div #panel class="table-options-panel mat-elevation-z8">
  <span class="title">Options</span>
  <button type="button" mat-icon-button class="close-button" (click)="closeBar()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <div class="table-options-panel-inner" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="mt-12 mb-12" fxFlex fxLayout="row" fxLayoutGap="3px" fxLayoutAlign="space-between center">
      @if (!disableExportCSV) {
      <button
        type="button"
        class="mt-sm-0"
        mat-stroked-button
        color="accent"
        (click)="exportFileColumns(fileTypes.csv)"
        fxFlex="45"
        [ngClass]="{ 'g-disabled': (isFileLoading$ | async).isCSVLoading }"
        data-testid="btn-export-csv"
      >
        @if ((isFileLoading$ | async).isCSVLoading) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent" class="spinner-inline"></mat-spinner>
        } @else {
        <mat-icon svgIcon="csv"></mat-icon>
        } {{ 'ADMIN.CLIENTS.EXPORT_CSV' | translate }}
      </button>
      } @if (!disableExportPDF) {
      <button
        type="button"
        class="mt-sm-0"
        mat-stroked-button
        color="accent"
        (click)="exportFileColumns(fileTypes.pdf)"
        fxFlex="45"
        [ngClass]="{ 'g-disabled': (isFileLoading$ | async).isPDFLoading }"
      >
        @if ((isFileLoading$ | async).isPDFLoading) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent" class="spinner-inline"></mat-spinner>
        } @else {
        <mat-icon svgIcon="pdf" color="accent"></mat-icon>
        } {{ 'ADMIN.CLIENTS.EXPORT_PDF' | translate }}
      </button>
      }
    </div>

    <div class="group pt-12">
      <h2>{{ 'MAIN.VISIBLE_TABLE_COLUMNS' | translate }}:</h2>
      @for (column of columnsToggleable; track column) {
      <mat-slide-toggle class="mt-16" (change)="toggleColumn(column)" [checked]="isColumnDisplayed(column)"
        >{{ (dynamicColumns && dynamicColumns[column]) || ('FIELDS.' + (fieldsRewrite[column] || column) | translate) }}</mat-slide-toggle
      >
      }
    </div>
  </div>
</div>
